<template>
  <div class="vouchers">
    <div class="vouchers__head">
      <div class="row m-0">
        <img height="37px" src="@/assets/image/image/andalin-point.png">
        <div class="vouchers__head--text">
          <h5>AndalinPoints</h5>
          <div v-if="isLoading" class="spinner__small--blue">
              <b-spinner label="Loading..."></b-spinner>
          </div>
          <p v-else><span>{{ mypoint }}</span> Points</p>
        </div>
      </div>
    </div>
    <div class="tabs__model4 mt-4">
      <b-card no-body class="row m-0">
        <b-tabs card>
           <b-tab title="Redeem Points" active>
            <b-card-text> <Exchange :andalinPoint="mypoint" :isLoading="isLoading" /> </b-card-text>
          </b-tab>
          <b-tab title="Redeem History">
            <b-card-text> <RedeemHistory/> </b-card-text>
          </b-tab>
          <b-tab title="Point History">
            <div>
              <b-card-text> <Historypoint/> </b-card-text>
            </div>
          </b-tab>
          <b-tab title="Leaderboard" v-if="this.leaderboardstatus === 1">
          <!-- <b-tab title="Leaderboard"> -->
            <b-card-text>
              <Leaderboard />
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Exchange from '@/components/andalinpoint/points/Exchange.vue'
import Historypoint from '@/components/andalinpoint/points/HistoryPoint.vue'
import RedeemHistory from '@/components/andalinpoint/points/RedeemHistory.vue'
import Leaderboard from '@/components/andalinpoint/points/Leaderboard.vue'

export default {
  name: 'andalinpoints',
  data () {
    return {
      mypoint: '0',
      leaderboardstatus: 0
    }
  },
  components: {
    Exchange,
    Historypoint,
    RedeemHistory,
    Leaderboard
  },
  computed: {
    ...mapGetters({
      pointItem: 'andalinpoint/pointitem',
      isLoading: 'andalinpoint/isLoadingpoint',
      isError: 'andalinpoint/errorpoint',

      redeemPoint: 'andalinpoint/redeemPoint',
      isLoadingredeemPoint: 'andalinpoint/isLoadingredeemPoint',
      errorredeemPoint: 'andalinpoint/errorredeemPoint',

      itemLeaderboard: 'andalinpoint/itemLeaderboard'
    })
  },
  mounted () {
    this.getDataLeaderboard()
    this.fetchPointItem() // dibutuhkan ketiga awal login
  },
  methods: {
    fetchPointItem () {
      this.$store.dispatch('andalinpoint/FETCH_POINT')
    },
    async getDataLeaderboard () {
      await this.$store.dispatch('andalinpoint/FETCH_POINT_LEADERBOARD')
      await this.getStatusLeaderboard()
    },
    getStatusLeaderboard () {
      return new Promise((resolve) => {
        if (this.itemLeaderboard || this.leaderboardstatus.status) {
          this.leaderboardstatus = this.itemLeaderboard.status
          return resolve()
        }
      })
    }
  },
  watch: {
    pointItem (data) {
      if (data) {
        this.mypoint = data.totalPoint.toString()
      }
    },
    redeemPoint (data) {
      if (data) {
        this.getDataLeaderboard()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/andalinpoint/Vouchers.vue